import { render } from "./CurrencyField.vue?vue&type=template&id=336ae4c7"
import script from "./CurrencyField.vue?vue&type=script&lang=js"
export * from "./CurrencyField.vue?vue&type=script&lang=js"

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CurrencyField.vue"]])

export default __exports__